var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"soonbox"},[_c('H1',[_vm._v("COMING SOON")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }